<div class="top-row">
  <label for="testDate">Selected Applicant(s)</label>
  <div class="selected-cont">
    <div>
      <app-chips
        *ngFor="let applicant of selectedApplicants"
        [item]="applicant"
        [removeItem]="true"
        (removeFromList)="fnRemoveItem($event)"
      ></app-chips>
    </div>
  </div>
  <div class="unselect-message" *ngIf="cannotSelectMessage">
    &#x2a; {{ cannotSelectMessage }}
  </div>
  <div class="unselect-message" *ngIf="notValidForNextStageMessage">
    &#x2a;&#x2a; {{ notValidForNextStageMessage }}
  </div>
  <div class="unselect-message" *ngIf="tertiaryMessage">
    &#x2a;&#x2a; {{ tertiaryMessage }}
  </div>
  <div *ngIf="showMessage" class="message">
    Must have 1 or more than 1 applicants to proceed furthur
  </div>
</div>
